import { Loadboard } from './Loadboard';

export interface LoadboardError {
  source: string | null;
  message: string;
  details?: Record<string, string>;
}

export class PostToLoadboardResponse {
  loadboard?: Loadboard;
  errors?: LoadboardError[];

  constructor(opts?: Partial<PostToLoadboardResponse>) {
    if (opts?.loadboard != null) {
      this.loadboard = new Loadboard(opts.loadboard);
    }
    if (opts?.errors != null) {
      this.errors = opts.errors;
    }
  }
}
